import { render, staticRenderFns } from "./DetalleAcumulado.vue?vue&type=template&id=115491d0&scoped=true"
import script from "./DetalleAcumulado.vue?vue&type=script&lang=js"
export * from "./DetalleAcumulado.vue?vue&type=script&lang=js"
import style0 from "./DetalleAcumulado.vue?vue&type=style&index=0&id=115491d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115491d0",
  null
  
)

export default component.exports